// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/SiteIcons/road.png");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../../public/SiteIcons/steering-4.png");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../../../public/SiteIcons/steering-3.png");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common Helpers Style - Start */

.ExistingPage-landingContainer-WDwlM {
	max-width: 1310px;
	width: 100%;
	display: block;
}

.ExistingPage-landingContent-aK8xe {
	margin-top: 60px;
}

.ExistingPage-pullCenter-n1izV {
	text-align: center;
	float: none;
	margin-left: auto;
	margin-right: auto;
	display: block;
}

/* Common Helpers Style - Start */

.ExistingPage-btnPrimary-_lZgi {
	border-color: var(--primary-border);
	background-color: var(--common-background-color);
	color: var(--white-text);
	border-radius: 6px;
	padding: 12px 21px;
	font-weight: 500;
	font-size: 18px;
}

.ExistingPage-btnPrimary-_lZgi:hover,
.ExistingPage-btnPrimary-_lZgi:focus,
.ExistingPage-btnPrimary-_lZgi:active,
.ExistingPage-btnPrimary-_lZgi:active:hover,
.ExistingPage-btnPrimary-_lZgi:active:focus {
	border-color: var(--primary-border) !important;
	background-color: var(--common-background-color) !important;
	color: var(--white-text);
}

.ExistingPage-btnPrimaryBorder-na_FD {
	border-color: var(--primary-border);
	color: var(--common-text-color);
	background-color: var(--primary-white-bg);
}

.ExistingPage-btnPrimaryBorder-na_FD:hover,
.ExistingPage-btnPrimaryBorder-na_FD:focus,
.ExistingPage-btnPrimaryBorder-na_FD:active,
.ExistingPage-btnPrimaryBorder-na_FD:active:hover,
.ExistingPage-btnPrimaryBorder-na_FD:active:focus {
	border-color: var(--primary-border);
	color: var(--common-text-color);
	background-color: var(--primary-white-bg);
}

.ExistingPage-btnSmall-E_wcv {
	padding: 5px 0px;
}

.ExistingPage-previewLink-Jp5J2 {
	color: var(--common-text-color);
	text-decoration: none;
	margin-left: 40px;
	font-size: 18px;
	line-height: 42px;
	vertical-align: middle;
}

.ExistingPage-previewLink-Jp5J2:hover,
.ExistingPage-previewLink-Jp5J2:active,
.ExistingPage-previewLink-Jp5J2:focus {
	color: var(--common-text-color);
	text-decoration: none;
}

.ExistingPage-previewLinkUserBan-yc0U5 {
	color: var(--common-text-color);
	text-decoration: none;
	font-size: 18px;
	line-height: 42px;
	vertical-align: middle;
}

.ExistingPage-previewLinkUserBan-yc0U5:hover,
.ExistingPage-previewLinkUserBan-yc0U5:active,
.ExistingPage-previewLinkUserBan-yc0U5:focus {
	color: var(--common-text-color);
	text-decoration: none;
}

.ExistingPage-formGroup-F0E_w {
	margin-bottom: 6px;
}

.ExistingPage-noPadding-oFnIy {
	padding: 0px !important;
}

.ExistingPage-pullRight-XzB51 {
	float: right;
}

.ExistingPage-pullLeft-a89xw {
	float: left;
}

.ExistingPage-landingTitle-umDNi {
	font-size: 32px;
	color: var(--common-text-color);
	margin: 0px 0px 30px 0px;
}

.ExistingPage-landingTitleStep-IKd4p {
	font-size: 16px;
	color: var(--common-text-color);
}

.ExistingPage-step-qClhB {
	font-size: 14px;
	color: #bbbbbb;
	text-transform: uppercase;
	font-weight: bold;
	line-height: 1.5;
}

.ExistingPage-horizontalLineThrough-MmxzW {
	display: block;
	margin: 30px 0;
	border-color: var(--primary-border);
	border: 0;
	height: 0;
	border-top: 1px solid var(--primary-border);
	width: 100%;
	font-size: 16px;
}

.ExistingPage-modalCaptionLink-XEhdx,
.ExistingPage-modalCaptionLink-XEhdx:hover,
.ExistingPage-modalCaptionLink-XEhdx:active,
.ExistingPage-modalCaptionLink-XEhdx:focus {
	color: var(--common-link-color) !important;
	font-size: 18px;
	cursor: pointer;
	text-decoration: none;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	padding: 0;
	border: 0;
	border-bottom: 1px solid var(--common-link-color) !important;
	border-radius: 0;
	background: transparent !important;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
	white-space: nowrap;
}

.ExistingPage-icon-DjWxf {
	font-size: 2.4em;
	line-height: 1;
	top: 50%;
	right: 0;
	color: var(--common-link-color);
	display: block;
}

.ExistingPage-spaceTop1-sHJA5 {
	margin-top: 6px;
}

.ExistingPage-spaceTop3-XgVrn {
	margin-top: 18px;
}

.ExistingPage-spaceTop5-Kyop1 {
	margin-top: 48px;
}

.ExistingPage-stepGrid-OwOMF {
	display: grid;
	grid-template-columns: 50% 50%;
	background: -webkit-gradient(linear, right top, left top, color-stop(50%, rgba(255, 255, 255, 1)), color-stop(48%, rgba(249, 249, 249, 1)));
	background: linear-gradient(270deg, rgba(255, 255, 255, 1) 50%, rgba(249, 249, 249, 1) 48%);
}

.ExistingPage-tickPosition-gadoV {
	position: absolute;
	bottom: 0;
	right: 0;
}

.ExistingPage-spaceBetween-VQpph {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	gap: 12px;
}

.ExistingPage-publishButtonRow-ZK3b8 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
}

.ExistingPage-becomeHostfooterLink-BMhTN,
.ExistingPage-becomeHostfooterLink-BMhTN:hover,
.ExistingPage-becomeHostfooterLink-BMhTN:focus {
	color: var(--common-link-color) !important;
	font-size: 18px;
	cursor: pointer;
	text-decoration: none;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	padding: 0;
	border: 0;
	border-bottom: 1px solid var(--common-link-color) !important;
	border-radius: 0;
	background: transparent !important;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
}

@media screen and (max-width: 640px) {
	.ExistingPage-previewLink-Jp5J2 {
		margin: 0px;
		display: inline-block;
	}

	.ExistingPage-previewLinkUserBan-yc0U5 {
		margin: 0px;
		display: inline-block;
	}

	.ExistingPage-button-IUHBD {
		display: block;
	}
}

.ExistingPage-step1Margin-j2od8 {
	margin-top: 20px;
}

.ExistingPage-imageSection-fZaQH {
	width: 100%;
	height: 100%;
	margin-top: 90px;
}

.ExistingPage-displayInline-c100V {
	display: inline-block;
}

@media screen and (max-width: 640px) {
	.ExistingPage-displayInline-c100V {
		display: inline-block;
		padding-right: 10px;
	}
}

/* Common Helpers Style - End */

/* New Design */

.ExistingPage-displayTable-dFpQY {
	display: table;
	width: 100%;
}

.ExistingPage-displayTableRow-QK7YZ {
	display: table-row;
}

.ExistingPage-displayTableCell-aVKzD {
	display: table-cell;
}

.ExistingPage-vtrTop-C8_N7 {
	vertical-align: top;
}

.ExistingPage-iconWidth-czH2S {
	width: 8%;
	position: relative;
}

.ExistingPage-borderLine-q2u4B::after {
	content: '';
	width: 5px;
	height: 100%;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	position: absolute;
	top: 0;
	right: 25px;
	z-index: 5;
	-webkit-box-shadow: 0px 0px 2px 1px #dedede;
	        box-shadow: 0px 0px 2px 1px #dedede;
}

.ExistingPage-circle-UeTSF {
	width: 100%;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	height: 20px;
	max-width: 20px;
	position: absolute;
	border: none;
	left: 7px;
	top: 0px;
	z-index: 6;
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	max-width: 32px;
	background-size: contain;
}

.ExistingPage-paddingBottom-AoR0V {
	padding-bottom: 48px;
}

.ExistingPage-paddingLeft-BLZSx {
	padding-left: 18px;
}

.ExistingPage-mainSectionPadding-obfC6 {
	padding-top: 48px !important;
	padding-bottom: 48px !important;
	background: var(--primary-white-bg);
}

.ExistingPage-contentSection-MzUw7 {
	background: #F3F7FF;
	padding: 24px;
	border-radius: 12px;
	border: 1px solid var(--primary-border);
	display: grid;
	grid-template-columns: auto auto;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	position: relative;
	margin-left: 10px;
	z-index: 0;
}

.ExistingPage-borderLineActive-Xjmek::after {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.ExistingPage-positionRelative-l38iL {
	position: relative;
}

.ExistingPage-mainSection-bZ01b {
	padding: 43px 54px;
}

.ExistingPage-mainSection-bZ01b::before {
	content: " ";
	position: absolute;
	width: 0;
	height: 0;
	bottom: auto;
	top: 0;
}

.ExistingPage-circleSuccess-VPsGa {
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
	width: 100%;
	height: 100%;
	background-repeat: no-repeat;
	max-width: 32px;
	background-size: contain;
}

.ExistingPage-userRight-tQ1jD img {
	border: 2px solid var(--common-link-color);
	border-radius: 50%;
	display: inline-block;
	padding: 5px;
	background-color: transparent;
}

.ExistingPage-sayCss-GwHe_ {
	width: 44px;
}

.ExistingPage-leftBg-QaylS {
	background: var(--common-gray-bg-color);
	padding: 93px 54px 0;
	position: relative;
	height: 100vh;
}

.ExistingPage-stepFooterImage-NahLT {
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	width: 100%;
	margin: 0 auto;
}

.ExistingPage-rightPadding-vrmkc {
	padding: 43px 54px 150px;
}

.ExistingPage-imgSection-Zeuc6 {
	width: 80px;
	height: 80px;
	border: 1px solid var(--primary-border);
	border-radius: 50%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	position: relative;
}

.ExistingPage-contentLeft-RfA0l {
	padding-left: 24px;
	padding-right: 12px;
}

.ExistingPage-flexCenter-ah2wV {
	display: grid;
	grid-template-columns: 80px auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.ExistingPage-contentSection-MzUw7::after {
	content: '';
	width: 100%;
	height: 130px;
	background: var(--primary-white-bg);
	border: 1px solid var(--primary-border);
	border-radius: 12px;
	position: absolute;
	left: 12px;
	top: -12px;
	z-index: -1;
}

.ExistingPage-exitFooter-JInI6 {
	position: fixed;
	bottom: 0;
	width: 100%;
	background: var(--primary-white-bg);
	z-index: 4;
	padding: 30px 54px;
	max-width: 50%;
	margin: 0px 0px 0px auto;
	right: 0px;
	left: 0px;
	-webkit-box-shadow: 0px -7px 16px #00000008;
	box-shadow: 0px -7px 16px #00000008;
}

.ExistingPage-noMargin-h2xLH {
	margin: 0;
}

@media (max-width: 1200px) and (min-width: 768px) {
	.ExistingPage-stepGrid-OwOMF {
		height: 50vh;
	}
}

@media screen and (max-width: 1199px) {
	.ExistingPage-circle-UeTSF {
		width: 100%;
		height: 20px;
		max-width: 20px;
		position: absolute;
		left: 14px;
		top: 0px;
		z-index: 5;
	}

	.ExistingPage-iconWidth-czH2S {
		width: 10%;
		position: relative;
	}

	.ExistingPage-contentSection-MzUw7::after {
		display: none;
	}

	.ExistingPage-contentSection-MzUw7 {
		background: var(--primary-white-bg);
	}
}

@media (max-width: 1024px) and (min-width: 768px) {
	.ExistingPage-contentSection-MzUw7 {
		margin-left: 0;
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		gap: 10px;
	}

	.ExistingPage-modalCaptionLink-XEhdx {
		margin-left: auto;
	}
}

@media screen and (max-width: 991px) {
	.ExistingPage-circle-UeTSF {
		width: 100%;
		height: 20px;
		max-width: 20px;
		position: relative;
		left: -37px;
		top: 0px;
		z-index: 5;
	}

	.ExistingPage-iconWidth-czH2S {
		width: 8%;
		position: relative;
		padding-left: 50px;
	}

	.ExistingPage-leftBg-QaylS {
		display: none;
	}

	.ExistingPage-stepGrid-OwOMF {
		grid-template-columns: 100%;
		background: transparent;
	}

	.ExistingPage-exitFooter-JInI6 {
		max-width: 100%;
	}
}

@media screen and (max-width: 767px) {
	.ExistingPage-rightPadding-vrmkc {
		padding: 43px 20px 150px;
	}

	.ExistingPage-contentSection-MzUw7 {
		margin-left: 0;
		gap: 10px;
		grid-template-columns: 100%;
	}

	.ExistingPage-contentSection-MzUw7::after {
		display: none;
	}

	.ExistingPage-contentLeft-RfA0l {
		padding-right: 10px;
	}

	.ExistingPage-exitFooter-JInI6 {
		padding: 30px 20px;
	}

	.ExistingPage-mbMargin-TsqhX {
		margin-bottom: 10px;
	}

	.ExistingPage-modalCaptionLink-XEhdx {
		margin-left: auto;
	}

	.ExistingPage-stepGrid-OwOMF {
		background: unset;
	}

}`, "",{"version":3,"sources":["webpack://./src/components/ListPlaceStep1/ExistingPage.css"],"names":[],"mappings":"AAAA,iCAAiC;;AAEjC;CACC,iBAAiB;CACjB,WAAW;CACX,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,kBAAkB;CAClB,cAAc;AACf;;AAEA,iCAAiC;;AACjC;CACC,mCAAmC;CACnC,gDAAgD;CAChD,wBAAwB;CACxB,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;;;;;CAKC,8CAA8C;CAC9C,2DAA2D;CAC3D,wBAAwB;AACzB;;AAEA;CACC,mCAAmC;CACnC,+BAA+B;CAC/B,yCAAyC;AAC1C;;AAEA;;;;;CAKC,mCAAmC;CACnC,+BAA+B;CAC/B,yCAAyC;AAC1C;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,qBAAqB;CACrB,iBAAiB;CACjB,eAAe;CACf,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;;CAGC,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;;;CAGC,+BAA+B;CAC/B,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,wBAAwB;AACzB;;AAEA;CACC,eAAe;CACf,+BAA+B;AAChC;;AAEA;CACC,eAAe;CACf,cAAc;CACd,yBAAyB;CACzB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,cAAc;CACd,mCAAmC;CACnC,SAAS;CACT,SAAS;CACT,2CAA2C;CAC3C,WAAW;CACX,eAAe;AAChB;;AAEA;;;;CAIC,0CAA0C;CAC1C,eAAe;CACf,eAAe;CACf,qBAAqB;CACrB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,UAAU;CACV,SAAS;CACT,4DAA4D;CAC5D,gBAAgB;CAChB,kCAAkC;CAClC,sCAA8B;SAA9B,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,cAAc;CACd,QAAQ;CACR,QAAQ;CACR,+BAA+B;CAC/B,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,2IAA2F;CAA3F,2FAA2F;AAC5F;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;CACT,mBAAe;KAAf,eAAe;CACf,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;;;CAGC,0CAA0C;CAC1C,eAAe;CACf,eAAe;CACf,qBAAqB;CACrB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,UAAU;CACV,SAAS;CACT,4DAA4D;CAC5D,gBAAgB;CAChB,kCAAkC;CAClC,sCAA8B;SAA9B,8BAA8B;AAC/B;;AAEA;CACC;EACC,WAAW;EACX,qBAAqB;CACtB;;CAEA;EACC,WAAW;EACX,qBAAqB;CACtB;;CAEA;EACC,cAAc;CACf;AACD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,qBAAqB;EACrB,mBAAmB;CACpB;AACD;;AAEA,+BAA+B;;AAE/B,eAAe;;AAEf;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,UAAU;CACV,YAAY;CACZ,yDAA2D;CAC3D,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,UAAU;CACV,2CAAmC;SAAnC,mCAAmC;AACpC;;AAEA;CACC,WAAW;CACX,yDAAiE;CACjE,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,SAAS;CACT,QAAQ;CACR,UAAU;CACV,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;CAC5B,+BAA+B;CAC/B,mCAAmC;AACpC;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,mBAAmB;CACnB,uCAAuC;CACvC,aAAa;CACb,gCAAgC;CAChC,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;CACrB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,yDAA2D;AAC5D;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,MAAM;AACP;;AAEA;CACC,yDAAiE;CACjE,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,eAAe;CACf,wBAAwB;AACzB;;AAEA;CACC,0CAA0C;CAC1C,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,6BAA6B;AAC9B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,uCAAuC;CACvC,oBAAoB;CACpB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,WAAW;CACX,cAAc;AACf;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uCAAuC;CACvC,kBAAkB;CAClB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,aAAa;CACb,mCAAmC;CACnC,uCAAuC;CACvC,mBAAmB;CACnB,kBAAkB;CAClB,UAAU;CACV,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,eAAe;CACf,SAAS;CACT,WAAW;CACX,mCAAmC;CACnC,UAAU;CACV,kBAAkB;CAClB,cAAc;CACd,wBAAwB;CACxB,UAAU;CACV,SAAS;CACT,2CAA2C;CAC3C,mCAAmC;AACpC;;AAEA;CACC,SAAS;AACV;;AAEA;CACC;EACC,YAA0B;CAC3B;AACD;;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,UAAU;CACX;;CAEA;EACC,UAAU;EACV,kBAAkB;CACnB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mCAAmC;CACpC;AACD;;AAEA;CACC;EACC,cAAc;EACd,mBAAe;MAAf,eAAe;EACf,SAAS;CACV;;CAEA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;CACX;;CAEA;EACC,SAAS;EACT,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,2BAA2B;EAC3B,uBAAuB;CACxB;;CAEA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,wBAAwB;CACzB;;CAEA;EACC,cAAc;EACd,SAAS;EACT,2BAA2B;CAC5B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;CAClB;;AAED","sourcesContent":["/* Common Helpers Style - Start */\n\n.landingContainer {\n\tmax-width: 1310px;\n\twidth: 100%;\n\tdisplay: block;\n}\n\n.landingContent {\n\tmargin-top: 60px;\n}\n\n.pullCenter {\n\ttext-align: center;\n\tfloat: none;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tdisplay: block;\n}\n\n/* Common Helpers Style - Start */\n.btnPrimary {\n\tborder-color: var(--primary-border);\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder-radius: 6px;\n\tpadding: 12px 21px;\n\tfont-weight: 500;\n\tfont-size: 18px;\n}\n\n.btnPrimary:hover,\n.btnPrimary:focus,\n.btnPrimary:active,\n.btnPrimary:active:hover,\n.btnPrimary:active:focus {\n\tborder-color: var(--primary-border) !important;\n\tbackground-color: var(--common-background-color) !important;\n\tcolor: var(--white-text);\n}\n\n.btnPrimaryBorder {\n\tborder-color: var(--primary-border);\n\tcolor: var(--common-text-color);\n\tbackground-color: var(--primary-white-bg);\n}\n\n.btnPrimaryBorder:hover,\n.btnPrimaryBorder:focus,\n.btnPrimaryBorder:active,\n.btnPrimaryBorder:active:hover,\n.btnPrimaryBorder:active:focus {\n\tborder-color: var(--primary-border);\n\tcolor: var(--common-text-color);\n\tbackground-color: var(--primary-white-bg);\n}\n\n.btnSmall {\n\tpadding: 5px 0px;\n}\n\n.previewLink {\n\tcolor: var(--common-text-color);\n\ttext-decoration: none;\n\tmargin-left: 40px;\n\tfont-size: 18px;\n\tline-height: 42px;\n\tvertical-align: middle;\n}\n\n.previewLink:hover,\n.previewLink:active,\n.previewLink:focus {\n\tcolor: var(--common-text-color);\n\ttext-decoration: none;\n}\n\n.previewLinkUserBan {\n\tcolor: var(--common-text-color);\n\ttext-decoration: none;\n\tfont-size: 18px;\n\tline-height: 42px;\n\tvertical-align: middle;\n}\n\n.previewLinkUserBan:hover,\n.previewLinkUserBan:active,\n.previewLinkUserBan:focus {\n\tcolor: var(--common-text-color);\n\ttext-decoration: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.landingTitle {\n\tfont-size: 32px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px 0px 30px 0px;\n}\n\n.landingTitleStep {\n\tfont-size: 16px;\n\tcolor: var(--common-text-color);\n}\n\n.step {\n\tfont-size: 14px;\n\tcolor: #bbbbbb;\n\ttext-transform: uppercase;\n\tfont-weight: bold;\n\tline-height: 1.5;\n}\n\n.horizontalLineThrough {\n\tdisplay: block;\n\tmargin: 30px 0;\n\tborder-color: var(--primary-border);\n\tborder: 0;\n\theight: 0;\n\tborder-top: 1px solid var(--primary-border);\n\twidth: 100%;\n\tfont-size: 16px;\n}\n\n.modalCaptionLink,\n.modalCaptionLink:hover,\n.modalCaptionLink:active,\n.modalCaptionLink:focus {\n\tcolor: var(--common-link-color) !important;\n\tfont-size: 18px;\n\tcursor: pointer;\n\ttext-decoration: none;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0;\n\tborder: 0;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n\tborder-radius: 0;\n\tbackground: transparent !important;\n\tbox-shadow: inherit !important;\n\twhite-space: nowrap;\n}\n\n.icon {\n\tfont-size: 2.4em;\n\tline-height: 1;\n\ttop: 50%;\n\tright: 0;\n\tcolor: var(--common-link-color);\n\tdisplay: block;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px;\n}\n\n.spaceTop5 {\n\tmargin-top: 48px;\n}\n\n.stepGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tbackground: linear-gradient(270deg, rgba(255, 255, 255, 1) 50%, rgba(249, 249, 249, 1) 48%);\n}\n\n.tickPosition {\n\tposition: absolute;\n\tbottom: 0;\n\tright: 0;\n}\n\n.spaceBetween {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n}\n\n.publishButtonRow {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n\tflex-wrap: wrap;\n\tjustify-content: space-between;\n}\n\n.becomeHostfooterLink,\n.becomeHostfooterLink:hover,\n.becomeHostfooterLink:focus {\n\tcolor: var(--common-link-color) !important;\n\tfont-size: 18px;\n\tcursor: pointer;\n\ttext-decoration: none;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0;\n\tborder: 0;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n\tborder-radius: 0;\n\tbackground: transparent !important;\n\tbox-shadow: inherit !important;\n}\n\n@media screen and (max-width: 640px) {\n\t.previewLink {\n\t\tmargin: 0px;\n\t\tdisplay: inline-block;\n\t}\n\n\t.previewLinkUserBan {\n\t\tmargin: 0px;\n\t\tdisplay: inline-block;\n\t}\n\n\t.button {\n\t\tdisplay: block;\n\t}\n}\n\n.step1Margin {\n\tmargin-top: 20px;\n}\n\n.imageSection {\n\twidth: 100%;\n\theight: 100%;\n\tmargin-top: 90px;\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n@media screen and (max-width: 640px) {\n\t.displayInline {\n\t\tdisplay: inline-block;\n\t\tpadding-right: 10px;\n\t}\n}\n\n/* Common Helpers Style - End */\n\n/* New Design */\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n}\n\n.vtrTop {\n\tvertical-align: top;\n}\n\n.iconWidth {\n\twidth: 8%;\n\tposition: relative;\n}\n\n.borderLine::after {\n\tcontent: '';\n\twidth: 5px;\n\theight: 100%;\n\tbackground-image: url('../../../public/SiteIcons/road.png');\n\tposition: absolute;\n\ttop: 0;\n\tright: 25px;\n\tz-index: 5;\n\tbox-shadow: 0px 0px 2px 1px #dedede;\n}\n\n.circle {\n\twidth: 100%;\n\tbackground-image: url('../../../public/SiteIcons/steering-4.png');\n\theight: 20px;\n\tmax-width: 20px;\n\tposition: absolute;\n\tborder: none;\n\tleft: 7px;\n\ttop: 0px;\n\tz-index: 6;\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tmax-width: 32px;\n\tbackground-size: contain;\n}\n\n.paddingBottom {\n\tpadding-bottom: 48px;\n}\n\n.paddingLeft {\n\tpadding-left: 18px;\n}\n\n.mainSectionPadding {\n\tpadding-top: 48px !important;\n\tpadding-bottom: 48px !important;\n\tbackground: var(--primary-white-bg);\n}\n\n.contentSection {\n\tbackground: #F3F7FF;\n\tpadding: 24px;\n\tborder-radius: 12px;\n\tborder: 1px solid var(--primary-border);\n\tdisplay: grid;\n\tgrid-template-columns: auto auto;\n\talign-items: baseline;\n\tjustify-content: space-between;\n\tposition: relative;\n\tmargin-left: 10px;\n\tz-index: 0;\n}\n\n.borderLineActive::after {\n\tbackground-image: url('../../../public/SiteIcons/road.png');\n}\n\n.positionRelative {\n\tposition: relative;\n}\n\n.mainSection {\n\tpadding: 43px 54px;\n}\n\n.mainSection::before {\n\tcontent: \" \";\n\tposition: absolute;\n\twidth: 0;\n\theight: 0;\n\tbottom: auto;\n\ttop: 0;\n}\n\n.circleSuccess {\n\tbackground-image: url('../../../public/SiteIcons/steering-3.png');\n\twidth: 100%;\n\theight: 100%;\n\tbackground-repeat: no-repeat;\n\tmax-width: 32px;\n\tbackground-size: contain;\n}\n\n.userRight img {\n\tborder: 2px solid var(--common-link-color);\n\tborder-radius: 50%;\n\tdisplay: inline-block;\n\tpadding: 5px;\n\tbackground-color: transparent;\n}\n\n.sayCss {\n\twidth: 44px;\n}\n\n.leftBg {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 93px 54px 0;\n\tposition: relative;\n\theight: 100vh;\n}\n\n.stepFooterImage {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\twidth: 100%;\n\tmargin: 0 auto;\n}\n\n.rightPadding {\n\tpadding: 43px 54px 150px;\n}\n\n.imgSection {\n\twidth: 80px;\n\theight: 80px;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 50%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: relative;\n}\n\n.contentLeft {\n\tpadding-left: 24px;\n\tpadding-right: 12px;\n}\n\n.flexCenter {\n\tdisplay: grid;\n\tgrid-template-columns: 80px auto;\n\talign-items: center;\n}\n\n.contentSection::after {\n\tcontent: '';\n\twidth: 100%;\n\theight: 130px;\n\tbackground: var(--primary-white-bg);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 12px;\n\tposition: absolute;\n\tleft: 12px;\n\ttop: -12px;\n\tz-index: -1;\n}\n\n.exitFooter {\n\tposition: fixed;\n\tbottom: 0;\n\twidth: 100%;\n\tbackground: var(--primary-white-bg);\n\tz-index: 4;\n\tpadding: 30px 54px;\n\tmax-width: 50%;\n\tmargin: 0px 0px 0px auto;\n\tright: 0px;\n\tleft: 0px;\n\t-webkit-box-shadow: 0px -7px 16px #00000008;\n\tbox-shadow: 0px -7px 16px #00000008;\n}\n\n.noMargin {\n\tmargin: 0;\n}\n\n@media (max-width: 1200px) and (min-width: 768px) {\n\t.stepGrid {\n\t\theight: calc(100vh - 50vh);\n\t}\n}\n\n@media screen and (max-width: 1199px) {\n\t.circle {\n\t\twidth: 100%;\n\t\theight: 20px;\n\t\tmax-width: 20px;\n\t\tposition: absolute;\n\t\tleft: 14px;\n\t\ttop: 0px;\n\t\tz-index: 5;\n\t}\n\n\t.iconWidth {\n\t\twidth: 10%;\n\t\tposition: relative;\n\t}\n\n\t.contentSection::after {\n\t\tdisplay: none;\n\t}\n\n\t.contentSection {\n\t\tbackground: var(--primary-white-bg);\n\t}\n}\n\n@media (max-width: 1024px) and (min-width: 768px) {\n\t.contentSection {\n\t\tmargin-left: 0;\n\t\tflex-wrap: wrap;\n\t\tgap: 10px;\n\t}\n\n\t.modalCaptionLink {\n\t\tmargin-left: auto;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.circle {\n\t\twidth: 100%;\n\t\theight: 20px;\n\t\tmax-width: 20px;\n\t\tposition: relative;\n\t\tleft: -37px;\n\t\ttop: 0px;\n\t\tz-index: 5;\n\t}\n\n\t.iconWidth {\n\t\twidth: 8%;\n\t\tposition: relative;\n\t\tpadding-left: 50px;\n\t}\n\n\t.leftBg {\n\t\tdisplay: none;\n\t}\n\n\t.stepGrid {\n\t\tgrid-template-columns: 100%;\n\t\tbackground: transparent;\n\t}\n\n\t.exitFooter {\n\t\tmax-width: 100%;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.rightPadding {\n\t\tpadding: 43px 20px 150px;\n\t}\n\n\t.contentSection {\n\t\tmargin-left: 0;\n\t\tgap: 10px;\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.contentSection::after {\n\t\tdisplay: none;\n\t}\n\n\t.contentLeft {\n\t\tpadding-right: 10px;\n\t}\n\n\t.exitFooter {\n\t\tpadding: 30px 20px;\n\t}\n\n\t.mbMargin {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.modalCaptionLink {\n\t\tmargin-left: auto;\n\t}\n\n\t.stepGrid {\n\t\tbackground: unset;\n\t}\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"landingContainer": `ExistingPage-landingContainer-WDwlM`,
	"landingContent": `ExistingPage-landingContent-aK8xe`,
	"pullCenter": `ExistingPage-pullCenter-n1izV`,
	"btnPrimary": `ExistingPage-btnPrimary-_lZgi`,
	"btnPrimaryBorder": `ExistingPage-btnPrimaryBorder-na_FD`,
	"btnSmall": `ExistingPage-btnSmall-E_wcv`,
	"previewLink": `ExistingPage-previewLink-Jp5J2`,
	"previewLinkUserBan": `ExistingPage-previewLinkUserBan-yc0U5`,
	"formGroup": `ExistingPage-formGroup-F0E_w`,
	"noPadding": `ExistingPage-noPadding-oFnIy`,
	"pullRight": `ExistingPage-pullRight-XzB51`,
	"pullLeft": `ExistingPage-pullLeft-a89xw`,
	"landingTitle": `ExistingPage-landingTitle-umDNi`,
	"landingTitleStep": `ExistingPage-landingTitleStep-IKd4p`,
	"step": `ExistingPage-step-qClhB`,
	"horizontalLineThrough": `ExistingPage-horizontalLineThrough-MmxzW`,
	"modalCaptionLink": `ExistingPage-modalCaptionLink-XEhdx`,
	"icon": `ExistingPage-icon-DjWxf`,
	"spaceTop1": `ExistingPage-spaceTop1-sHJA5`,
	"spaceTop3": `ExistingPage-spaceTop3-XgVrn`,
	"spaceTop5": `ExistingPage-spaceTop5-Kyop1`,
	"stepGrid": `ExistingPage-stepGrid-OwOMF`,
	"tickPosition": `ExistingPage-tickPosition-gadoV`,
	"spaceBetween": `ExistingPage-spaceBetween-VQpph`,
	"publishButtonRow": `ExistingPage-publishButtonRow-ZK3b8`,
	"becomeHostfooterLink": `ExistingPage-becomeHostfooterLink-BMhTN`,
	"button": `ExistingPage-button-IUHBD`,
	"step1Margin": `ExistingPage-step1Margin-j2od8`,
	"imageSection": `ExistingPage-imageSection-fZaQH`,
	"displayInline": `ExistingPage-displayInline-c100V`,
	"displayTable": `ExistingPage-displayTable-dFpQY`,
	"displayTableRow": `ExistingPage-displayTableRow-QK7YZ`,
	"displayTableCell": `ExistingPage-displayTableCell-aVKzD`,
	"vtrTop": `ExistingPage-vtrTop-C8_N7`,
	"iconWidth": `ExistingPage-iconWidth-czH2S`,
	"borderLine": `ExistingPage-borderLine-q2u4B`,
	"circle": `ExistingPage-circle-UeTSF`,
	"paddingBottom": `ExistingPage-paddingBottom-AoR0V`,
	"paddingLeft": `ExistingPage-paddingLeft-BLZSx`,
	"mainSectionPadding": `ExistingPage-mainSectionPadding-obfC6`,
	"contentSection": `ExistingPage-contentSection-MzUw7`,
	"borderLineActive": `ExistingPage-borderLineActive-Xjmek`,
	"positionRelative": `ExistingPage-positionRelative-l38iL`,
	"mainSection": `ExistingPage-mainSection-bZ01b`,
	"circleSuccess": `ExistingPage-circleSuccess-VPsGa`,
	"userRight": `ExistingPage-userRight-tQ1jD`,
	"sayCss": `ExistingPage-sayCss-GwHe_`,
	"leftBg": `ExistingPage-leftBg-QaylS`,
	"stepFooterImage": `ExistingPage-stepFooterImage-NahLT`,
	"rightPadding": `ExistingPage-rightPadding-vrmkc`,
	"imgSection": `ExistingPage-imgSection-Zeuc6`,
	"contentLeft": `ExistingPage-contentLeft-RfA0l`,
	"flexCenter": `ExistingPage-flexCenter-ah2wV`,
	"exitFooter": `ExistingPage-exitFooter-JInI6`,
	"noMargin": `ExistingPage-noMargin-h2xLH`,
	"mbMargin": `ExistingPage-mbMargin-TsqhX`
};
module.exports = ___CSS_LOADER_EXPORT___;
